import { Pipe, PipeTransform } from '@angular/core';

import { ContractStatus } from '@gi/enums/contract-status.enum';

@Pipe({
  name: 'disableContractStatus',
  standalone: true
})
export class DisableContractStatusPipe implements PipeTransform {
  transform(currentStatus: ContractStatus, nextStatus: ContractStatus): boolean {
    if (currentStatus === nextStatus) {
      return true;
    }

    switch (currentStatus) {
      case ContractStatus.draft:
        return [ContractStatus.sent, ContractStatus.signed].includes(nextStatus);
      case ContractStatus.sent:
        return [ContractStatus.signed].includes(nextStatus);
      case ContractStatus.signed:
        return [ContractStatus.draft, ContractStatus.sent].includes(nextStatus);
      case ContractStatus.lost:
        return [ContractStatus.draft, ContractStatus.sent, ContractStatus.signed].includes(nextStatus);
      default:
        return false;
    }
  }
}
